import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useTranslations } from '@lang';
import { StickyBarWrapper } from '@common/components';
import SectionContainer from '@common/components/SectionContainer';

const RestaurantName = styled.p`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
`;

const Column = styled.div`
  padding-right: 10px;
`;

const StickyBar = ({ restaurant, id, isModalOpen = false }) => {
  const { t } = useTranslations();

  return (
    isModalOpen && (
      <StickyBarWrapper
        // if modal is open, sticky bar should be above navmenu and flynav
        zIndex={isModalOpen ? 9999 : null}
      >
        <SectionContainer>
          <Row>
            <Column>
              <RestaurantName>{restaurant}</RestaurantName>
              <p>{t('basket.diningReservation')}</p>
            </Column>
            <div id={id} />
          </Row>
        </SectionContainer>
      </StickyBarWrapper>
    )
  );
};

StickyBar.propTypes = {
  id: PropTypes.string.isRequired,
  restaurant: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool,
};

export default StickyBar;
